import { chunk } from 'utils';
import moment from 'moment';
import usdlRules from '_src/utils/usdlRules';

export default [
  { name: 'firstName', label: 'First Name', component: 'viewOnly' },
  { name: 'lastName', label: 'Last Name', component: 'viewOnly' },
  { name: 'mailingAddress', label: 'Address', component: 'googleAutocomplete' },
  { name: 'phone', label: 'Phone', component: 'input', masked: true },
  { name: 'email', label: 'Email', component: 'input', masked: true },
  { name: 'birthdate', label: 'Birthdate', component: 'date', masked: true },
  {
    name: 'gender',
    label: 'Gender',
    component: 'select',
    options: [
      { id: 'male', label: 'Male' },
      { id: 'female', label: 'Female' },
      { id: 'hidden', label: 'Prefer not to say' }
    ],
    masked: true
  },
  { name: 'status', label: 'Status', component: 'viewOnly' },
  {
    name: 'license',
    label: 'Driver License',
    component: 'input',
    onChange: (value = '', { setField }) => {
      const license = value.replace(/-/g, '');
      const rule = usdlRules.find(({ rule }) => new RegExp(rule).test(license));

      if (rule) {
        const state = GLOBALS.states.find(state => state.id === rule.state);
        setField('licenseState', state.label);
      } else {
        setField('licenseState', '');
      }
    },
    normalize: value => {
      let normalizedValue = value.toUpperCase();
      normalizedValue = normalizedValue.replace(/-/g, '');
      normalizedValue = chunk(normalizedValue.split(''), 4);
      normalizedValue = normalizedValue.map((arrChunk, index) => {
        let postFix = arrChunk.length === 4 && index !== normalizedValue.length - 1 ? '-' : '';

        return arrChunk.join('') + postFix;
      });

      return normalizedValue.join('');
    },
    masked: true
  },
  { name: 'licenseState', label: 'Drivers License State', component: 'viewOnly', masked: true },
  {
    name: 'dateClassBegins',
    label: 'Date Class Begins',
    component: 'viewOnly',
    format: value => (value ? moment(value).parseZone().format('MM/DD/YYYY') : '')
  },
  { name: 'graduationDate', label: 'Graduation Date', component: 'date' },
  { name: 'carrierRecruiterName', label: "Recruiter's Name", component: 'viewOnly' },
  { name: 'cdlDate', label: 'CDL Date', component: 'date' },
  { name: 'permitExpiration', label: 'Permit Expiration', component: 'date' },
  { name: 'currentEmployer', label: 'Current Employer', component: 'viewOnly' },
  { name: 'classType', label: 'Class type', component: 'viewOnly' },
  { name: 'profilePicture', label: 'Student picture', component: 'profilePicture', editable: true },
  {
    name: 'current_job',
    label: 'Do you currently have a job?',
    component: 'select',
    options: [
      { id: true, label: 'Yes' },
      { id: false, label: 'No' }
    ]
  },
  { name: 'current_job_name', label: 'Company Name', component: 'input' },
  {
    name: 'automaticGear',
    label: 'Transmission Type',
    component: 'select',
    options: [
      { id: true, label: 'Automatic' },
      { id: false, label: 'Manual' }
    ]
  }
];
